// Story 10.3 — `useInfiniteQuery` sobre `GET /bots/:id/conversations`.
import { useInfiniteQuery } from '@tanstack/react-query';
import { conversationsApi } from '@/lib/api-client';
import type { ConversationListResponse } from '@/lib/conversations-types';
import { type ConversationFilters, queryKeys } from '@/lib/query-keys';

const PAGE_SIZE = 20;

export function useConversations(botId: number, filters: ConversationFilters) {
  return useInfiniteQuery<ConversationListResponse>({
    queryKey: queryKeys.conversationsList(botId, filters),
    queryFn: ({ pageParam = 0 }) =>
      conversationsApi.list(botId, { ...filters, limit: PAGE_SIZE, offset: pageParam as number }),
    initialPageParam: 0,
    getNextPageParam: (lastPage) => {
      const consumed = lastPage.pagination.offset + lastPage.data.length;
      return consumed < lastPage.pagination.total ? consumed : undefined;
    },
    staleTime: 30_000,
    enabled: Number.isFinite(botId),
  });
}
